import { jsx as o } from "react/jsx-runtime";
function l(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.35742 15.5V4.91504H15.1816V15.5H6.35742ZM0.181641 15.5V4.91504H5.47656V15.5H0.181641ZM0.181641 4.03125V0.5H15.1816V4.03125H0.181641Z"
        }
      )
    }
  );
}
export {
  l as BlogLayoutIcon
};
